module.exports = __webpack_public_path__ + "media/images/pic/brodno/team/teachers/konrad-knitter-de5a8b9747f5e1ae12171f8689d6acfb.webp";